import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const InputFieldWrapper = styled.div`
  max-width: ${spacing.x24};
  padding-left: ${spacing.double};
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing.half};
`;
